import { Button, ButtonIcon, css, EllipsisIcon, MoveIcon, Plus1Icon, styled, Tooltip } from 'canoe';
import React from 'react';

import { TooltipBodyWithShortcuts } from 'craft/components/TooltipBodyWithShortcuts';

import { StyledButtonIcon } from './FloatingMenuContext';

const ActionButtons = styled.div`
  ${({ theme }) => css`
    height: 40px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: ${theme.spaces.xs};
  `}
`;

const ContextButtonWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

interface Props {
  onAdd: VoidFunction;
  addLabel: string;
  onContextClick?: VoidFunction;
  menuPosition: 'top' | 'bottom';
  onToggleMenuPosition: VoidFunction;
}

export const FloatingMenuActions = ({
  onAdd,
  addLabel,
  onContextClick,
  menuPosition,
  onToggleMenuPosition,
}: Props) => {
  return (
    <ActionButtons id="floating-menu-action-buttons">
      <Button
        variant="secondary"
        appearance="text"
        size="small"
        icon={Plus1Icon}
        onClick={onAdd}
        inline
      >
        {addLabel}
      </Button>

      {/* Temporarily add button directly in floating menu actions until there are more actions to add to context menu */}
      <Tooltip
        placement={menuPosition === 'top' ? 'bottom' : 'top'}
        offset="xxs"
        content={
          <TooltipBodyWithShortcuts
            content={`Move to ${menuPosition === 'top' ? 'Bottom' : 'Top'}`}
          />
        }
      >
        <StyledButtonIcon
          size="small"
          icon={MoveIcon}
          onClick={onToggleMenuPosition}
          radius="small"
          color="white"
          menuPosition={menuPosition}
        />
      </Tooltip>

      {onContextClick && (
        <ContextButtonWrapper id="floating-menu-context-button-wrapper">
          <ButtonIcon
            id="floating-menu-context-button"
            color="neutral"
            size="xsmall"
            icon={EllipsisIcon}
            onClick={onContextClick}
            radius="xsmall"
          />
        </ContextButtonWrapper>
      )}
    </ActionButtons>
  );
};
